import React from 'react';
import { getContext } from 'common';
import Styled from './styles';

export interface AppContentWrapperProps extends React.ComponentPropsWithRef<'div'> {
  /** The content of the `AppContentWrapper`, consider using `AppToolbar` and `AppContent`. */
  children: React.ReactNode;
}

/** `AppContentWrapper` should be nested in `AppBody`. All props will be provided to the root DOM element. */
const AppContentWrapper = React.forwardRef<HTMLElement, AppContentWrapperProps>((props, ref) => getContext(({ RTL }: { RTL: boolean }) => {
  const { children, ...otherProps } = props;
  return <Styled.AppContentWrapper ref={ref} RTL={RTL} {...otherProps}>{children}</Styled.AppContentWrapper>;
}));

AppContentWrapper.displayName = 'AppContentWrapper';

export default AppContentWrapper;
